import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Tabs, { TabElement } from '../../../Tabs/Tabs';
import SwipeableViews from 'react-swipeable-views';
import SendTickets from './components/SendTickets/SendTickets';
import { useTheme } from '../../../theme';
import Download from './components/Download/Download';
import ModalConfirm from '../../../ModalConfirm';

interface Props {
	open: boolean;
	onClose: () => void;
	everyPortPassengerIds?: string[];
	withEveryTravelServices?: boolean;
}

const DOWNLOAD_TAB = 0;
const SEND_TO_EMAIL_TAB = 1;

const TicketsModal: React.FC<Props> = ({ open, onClose, everyPortPassengerIds, withEveryTravelServices }) => {
	const [tab, setTab] = React.useState(DOWNLOAD_TAB);
	const { t } = useTranslation('FlightInfoCard');

	const theme = useTheme('FlightInfoCard').TicketsModal;

	const tabs: TabElement[] = [
		{
			header: t('Download'),
			label: null,
			value: DOWNLOAD_TAB
		},
		{
			header: t('Send to email'),
			label: null,
			value: SEND_TO_EMAIL_TAB
		}
	];

	const renderContent = () => {
		return (
			<div>
				<Tabs
					indicatorClassName={theme.indicator}
					tabHeaderClassName={theme.tabHeader}
					rootTabsClassName={theme.tabs}
					tabs={tabs}
					onChange={setTab}
					selected={tab}
				/>

				<SwipeableViews index={tab} disabled={true}>
					<Download
						everyPortPassengerIds={everyPortPassengerIds}
						withEveryTravelServices={withEveryTravelServices}
					/>

					<div>
						<SendTickets />
					</div>
				</SwipeableViews>
			</div>
		);
	};

	return (
		<ModalConfirm
			size={'small'}
			onClose={onClose}
			isOpen={open}
			title={t('Tickets, documents')}
			classes={{ title: theme.modalTitle, paper: theme.modalPaper }}
		>
			{renderContent()}
		</ModalConfirm>
	);
};

export default TicketsModal;
